import { Box, Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react';

import { ProviderAvailabilities } from 'src/dropInClinic/providerAvailability';
import { PopInClinicQueueTab } from 'src/popInClinic/PopInClinicQueueTab';
import { PopInClinicSection } from 'src/popInClinic/types';

export function PopInClinicQueue(): JSX.Element {
  const [activeSection, setActiveSection] = useState(PopInClinicSection.Queue);

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Pop-In Clinic Queue</h2>
      <Box style={{ borderBottom: '1px solid #ccc', marginBottom: '1rem' }}>
        <Tabs
          value={activeSection}
          onChange={(_, v) => setActiveSection(v)}
          aria-label="Pop-In Clinic Queue sections"
        >
          <Tab value={PopInClinicSection.Queue} label="Current Queue" />
          <Tab value={PopInClinicSection.Availability} label="Availability" />
        </Tabs>
      </Box>
      {activeSection === PopInClinicSection.Queue && <PopInClinicQueueTab />}
      {activeSection === PopInClinicSection.Availability && <ProviderAvailabilities />}
    </div>
  );
}
